import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavOpenEmitterService } from '../common-services/nav-open-emitter.service';
import { PlateType } from '../constants/PlateType';
import { MessagesNewService } from '../messages-new/messages.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-component-header',
  templateUrl: './component-header.component.html',
  styleUrls: ['./component-header.component.css']
})
export class ComponentHeaderComponent {

	@Input() urls: Array<string> = [];
	@Input() tabs: Array<string> = [];
	viewType: string = '';
	selectedTabIndex: number = 0;
	searchTypeOptions: Array<any> = [];
	navOpen: boolean = false;

	@Output() selectedTabEmitter: EventEmitter<number> = new EventEmitter<number>();

	constructor(
		@Inject(NavOpenEmitterService) private readonly navOpenEmitterService: NavOpenEmitterService,
		private readonly responsive: BreakpointObserver,
		private readonly messagesService: MessagesNewService,
		private readonly router: Router
	){}

	ngOnInit(){
		this.responsive.observe([
			Breakpoints.Handset,
			Breakpoints.Tablet,
			Breakpoints.Web
		]).subscribe(result => {
			const breakpoints = result.breakpoints;
			if (breakpoints[Breakpoints.WebPortrait] || breakpoints[Breakpoints.WebLandscape]) {
				this.viewType = 'web';
			} else if (breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
				this.viewType = 'tablet';
			} else if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]) {
				this.viewType = 'handset';
			}
		});
		this.searchTypeOptions.push({label:"Plate", value:PlateType.PLATE});
		this.searchTypeOptions.push({label:"Sample", value:"SAMPLE"});
		this.searchTypeOptions.push({label:"Array", value:PlateType.ARRAY});
		if(this.viewType!='web'){
			this.navOpenEmitterService.change.subscribe(navOpen => {
				this.navOpen = navOpen;
				console.log("Nav Open: " + this.navOpen)
			});
		}else{
			this.navOpen = true;
		}

		this.setSelectedTabIndexBasedOnUrl()
	}

	changeTab(index: number){
		this.selectedTabIndex = index;
		this.selectedTabEmitter.emit(index);
	}

	findAndRedirect(){
		this.messagesService.addWarningMessage({
			severity:'warn',
			summary: "Search is not available for now. Will be released in future updates."
		})
	}

	setSelectedTabIndexBasedOnUrl(){
		if(this.urls.length === 0){
			return;
		}

		this.urls.forEach((url, index) => {
			if (this.router.url.endsWith(url)){
				this.selectedTabIndex = index;
			}
		})
	}
}
